import { createSlice } from '@reduxjs/toolkit';


const currentProduct = 
  {
    id: 0,
    name: '',
    description: '',
    sku: '',
    vendor_id: 0,
    vendor: '',
    custom_name: '',
    customer_id: 0,
    customer: '',
    quantity: 0,
    items_count: 0,
    measure_id: 0,
    category_id: 0,
    picture: '',
    items: [],
    pictureFile: '',
  }

  const currentAttribute = {
    id: 0,
    name: '',
    value: '',
  };

  const currentItem = 
    {
      id: 0,
      consecutive: 0,
      num_factura: '',
      product_id: 0,
      product: '',
      quantity: 0,
      description: '',
      place_id: 0,
      place: '',
      price: 0,
      currency: '',
      sku_qr: '',
      arrivedAt: '',
      old_quantity: 0,
    }

    const currentItemAttribute = {  
      id: 0,
      name: '',
      value: '',
    }

    const currentCustomer = {
      id: 0,
      name: '',
      username: '',
    };

export const stockSlice = createSlice({
  name: 'stock',
  initialState: {
    stock: [],
    currentProduct: currentProduct,
    currentItem: currentItem,
    attributes: [],
    productAttributes: [],
    currentAttribute: currentAttribute,
    itemAttributes: [],
    attributesForItem: [],
    currentItemAttribute: currentItemAttribute,
    customers: [],
    currentCustomer: currentCustomer,
    transactions : [],
  },
  reducers: {
    setStock: (state, action) => {
      state.stock = action.payload;
    },
    addProduct: (state, action) => {
      state.stock.push(action.payload);
    },
    deleteProduct: (state, action) => {
      state.stock = state.stock.filter((product) => product.id !== action.payload);
    },
    updateProduct: (state, action) => {
      state.stock = state.stock.map((product) => (product.id === action.payload.id ? action.payload : product));
    },
    viewProduct: (state, action) => {
      state.currentProduct = action.payload;
    },
    getProduct: (state, action) => {
      state.currentProduct = state.stock.find((product) => product.id === action.payload);
    },
    resetCurrentProduct: (state) => {
      state.currentProduct = currentProduct;
    },
    setItems: (state, action) => {
      state.currentProduct.items = action.payload;
    },
    addItem: (state, action) => {
      state.currentProduct.items.push(action.payload);
    },
    deleteItem: (state, action) => {
      state.currentProduct.items = state.currentProduct.items.filter((item) => item.id !== action.payload);
    },
    updateItem: (state, action) => {
      state.currentProduct.items = state.currentProduct.items.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );
    },
    viewItem: (state, action) => {
      state.currentItem = action.payload;
    },
    resetCurrentItem: (state) => {
      state.currentItem = currentItem
    },
    setAttributes: (state, action) => {
      state.attributes = action.payload;
    },
    addAttribute: (state, action) => {
      state.attributes.push(action.payload);
    },
    setProductAttributes: (state, action) => {
      state.productAttributes = action.payload;
    },
    addProductAttribute: (state, action) => {
      let attribute = {
        id: action.payload.id,
        name: action.payload.name,
        value: action.payload.value,
      };
      if (attribute.id === 0) {
        // get max id from current attributes
        let maxId = 0;
        state.productAttributes.forEach((attr) => {
          if (attr.id > maxId) {
            maxId = attr.id;
          }
        });
        state.attributes.forEach((attr) => {
          if (attr.id > maxId) {
            maxId = attr.id;
          }
        });
        attribute.id = maxId + 1;
      }
      state.productAttributes.push(attribute);
    },
    deleteProductAttribute: (state, action) => {
      state.productAttributes = state.productAttributes.filter((attribute) => attribute.id !== action.payload);
    },
    updateProductAttribute: (state, action) => {
      state.productAttributes = state.productAttributes.map((attribute) =>
        attribute.id === action.payload.id ? action.payload : attribute
      );
    },
    viewProductAttribute: (state, action) => {
      state.currentAttribute = action.payload;
    },
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    viewCustomer: (state, action) => {
      state.currentCustomer = action.payload;
    },
    addCustomer: (state, action) => {
      state.customers.push(action.payload);
    },
    resetCurrentCustomer: (state) => {
      state.currentCustomer = {
        id: 0,
        name: '',
        username: '',
      };
    },
    addItemToProduct: (state, action) => {
      state.stock.forEach((product) => {
        if (product.id === action.payload.product_id) {
          product.items_count = product.items_count + 1;
          product.quantity = parseFloat(product.quantity) + parseFloat(action.payload.quantity);
        }
      });
    },
    updateQuantity: (state, action) => {
      console.log('Update quantity', action.payload)
      state.stock.forEach((product) => {
        if (product.id === parseInt(action.payload.product_id)) {
          console.log('found product', product)
          // find item 
          const item = product.items.find((item) => item.id === parseInt(action.payload.id));
          if (item) {
            console.log('found item', item)
            item.quantity = parseFloat(action.payload.quantity);
          }
        }
      });
    },
    updateItemInProduct: (state, action) => {
      state.stock.forEach((product) => {
        if (product.id === action.payload.product_id) {
          const productQuantity = !isNaN(parseFloat(product.quantity)) ? parseFloat(product.quantity) : 0;
          const itemQuantity = !isNaN(parseFloat(action.payload.quantity)) ? parseFloat(action.payload.quantity) : 0;
          const oldQuantity = !isNaN(parseFloat(action.payload.old_quantity)) ? parseFloat(action.payload.old_quantity) : 0;
          product.quantity = productQuantity + itemQuantity - oldQuantity;
        }
      });
    },
    viewItemAttribute: (state, action) => {
      state.currentItemAttribute = action.payload;
    },
    setItemAttributes: (state, action) => {
      state.itemAttributes = action.payload;
    },
    addItemAttribute: (state, action) => {
      let attribute = {
        id: action.payload.id,
        name: action.payload.name,
        value: action.payload.value,
      };
      if (attribute.id === 0) {
        // get max id from current attributes
        let maxId = 0;
        state.itemAttributes.forEach((attr) => {
          if (attr.id > maxId) {
            maxId = attr.id;
          }
        });
        state.attributesForItem.forEach((attr) => {
          if (attr.id > maxId) {
            maxId = attr.id;
          }
        });
        attribute.id = maxId + 1;
      }
      state.itemAttributes.push(attribute);
    },
    deleteItemAttribute: (state, action) => {
      state.itemAttributes = state.itemAttributes.filter((attribute) => attribute.id !== action.payload);
    },
    resetItemAttributes: (state) => {
      state.itemAttributes = [];
    },
    setTransactions: (state, action) => {
      state.transactions = action.payload;
    },
  },
});

export const {
  setStock,
  addProduct,
  deleteProduct,
  updateProduct,
  viewProduct,
  resetCurrentProduct,
  setItems,
  addItem,
  deleteItem,
  updateItem,
  viewItem,
  resetCurrentItem,
  setAttributes,
  setProductAttributes,
  addProductAttribute,
  deleteProductAttribute,
  updateProductAttribute,
  viewProductAttribute,
  setCustomers,
  viewCustomer,
  addCustomer,
  resetCurrentCustomer,
  addItemToProduct,
  updateItemInProduct,
  attributesForItem,
  setItemAttributes,
  viewItemAttribute,
  deleteItemAttribute,
  itemAttributes,
  addItemAttribute,
  resetItemAttributes,
  setTransactions,
  updateQuantity
} = stockSlice.actions;

export const selectStock = (state) => state.stock.stock;
export const selectCurrentProduct = (state) => state.stock.currentProduct;
export const selectCurrentItem = (state) => state.stock.currentItem;
export const selectAttributes = (state) => state.stock.attributes;
export const selectProductAttributes = (state) => state.stock.productAttributes;
export const selectCurrentAttribute = (state) => state.stock.currentAttribute;
export const selectCustomers = (state) => state.stock.customers;
export const selectCurrentCustomer = (state) => state.stock.currentCustomer;
export const selectItemAttributes = (state) => state.stock.itemAttributes;
export const selectCurrentItemAttribute = (state) => state.stock.currentItemAttribute;
export const selectTransactions = (state) => state.stock.transactions;

export default stockSlice.reducer;
